import type { ReactNode } from 'react';

import { Separator } from '@/components/ui/separator.tsx';
import { SidebarTrigger } from '@/components/ui/sidebar.tsx';

type AppContentProps = {
  title?: ReactNode;
  children?: ReactNode | ReactNode[];
};

const AppContent = ({ title, children }: AppContentProps) => {
  return (
    <>
      <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-6" />
          <h1 className="text-base font-medium">{title}</h1>
        </div>
      </header>

      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 p-4 md:gap-6 md:p-6">{children}</div>
        </div>
      </div>
    </>
  );
};

export default AppContent;
